import { OktaAuth } from "@okta/okta-auth-js";
import ApiClient from "../apiClient/api";
import { handshaking } from "../configs/ApiRoutes";
import Url from "../configs/UrlContants";
import config from "./config";

export const externalOktaAuth = new OktaAuth(config.externalOidc);

export const initializeExternalSession = async () => {
    const randomBytes = new Uint8Array(16);
    window.crypto.getRandomValues(randomBytes);
    const randomSuffix = Array.from(randomBytes, (byte) =>
        byte.toString(16).padStart(2, "0")
    ).join("");
    const sessionId = `_ss_${Date.now()}i${randomSuffix}`;
    const response = await ApiClient.postWithParams(
        `${Url.apiUrlWeb}${handshaking}`,
        { sessionId }
    );

    if (!response?.success || !response.data) {
        throw new Error("External session initialization failed.");
    }

    sessionStorage.setItem("_ss_i", response.data.sessionId);
    sessionStorage.setItem("_rr_n_dts", response.data.rnduts);
    sessionStorage.setItem("_en_cs", response.data.encstr);
};

export const isExternalAuthenticated = () => {
    if (sessionStorage.getItem("externalAuthenticated") !== "true") {
        return false;
    }

    try {
        const token = JSON.parse(sessionStorage.getItem("accessToken"));
        return Boolean(token?.accessToken && token.expiresAt * 1000 > Date.now());
    } catch (error) {
        return false;
    }
};